export class ControlHelper {
    static getAllControls(root) {
        return this._getControls(root, true);
    }
    static getControls(element) {
        return this._getControls(element, false);
    }
    static _getControls(root, deep) {
        let controls = [];
        let queue = this._getChildren(root);
        while (queue.length > 0) {
            let current = queue.shift();
            if (current.site) {
                controls.push(current);
                if (deep)
                    this._getChildren(current).map(c => queue.push(c));
            }
            else
                this._getChildren(current).map(c => queue.push(c));
        }
        return controls;
    }
    static _getChildren(element) {
        let elements = [];
        for (let i = 0; i < element.children.length; i++)
            elements.push(element.children.item(i));
        let sroot = element.shadowRoot;
        if (sroot) {
            for (let i = 0; i < sroot.children.length; i++)
                elements.push(sroot.children.item(i));
        }
        return elements;
    }
}
//# sourceMappingURL=control-helper.js.map